const ResizableDivider = ({ containerRef, leftWidth, onWidthChange }) => {
  const handleMouseDown = (e) => {
    e.preventDefault();
    const startX = e.clientX;
    const startLeftWidth = leftWidth;

    const handleMouseMove = (event) => {
      if (containerRef.current) {
        const deltaX = event.clientX - startX;
        const containerWidth = containerRef.current.offsetWidth;
        let newLeftWidth =
          (((startLeftWidth * containerWidth) / 100) + deltaX) / containerWidth * 100;
        newLeftWidth = Math.max(20, Math.min(80, newLeftWidth));
        onWidthChange(newLeftWidth);
      }
    };

    const handleMouseUp = () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  return (
    <div
      className="resizer"
      onMouseDown={handleMouseDown}
      style={{
        width: "2px",
        cursor: "ew-resize",
        backgroundColor: "gray",
        position: "relative",
        userSelect: "none",
        zIndex: 1,
      }}
    >
      <div
        className="resize-icon"
        style={{
          width: "40px",
          height: "40px",
          backgroundColor: "white",
          border: "2px solid black",
          borderRadius: "2px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 1,
        }}
      >
        <span
          style={{
            fontSize: "18px",
            fontWeight: "bold",
            color: "black",
            marginBottom: "2px",
          }}
        >
          ↔
        </span>
      </div>
    </div>
  );
};

export default ResizableDivider;
